// extracted by mini-css-extract-plugin
module.exports = {"circleContainer":"Ragam_circleContainer__2Co5C","circleLogo":"Ragam_circleLogo__Ubwnw","namaOsfak":"Ragam_namaOsfak__298ow","logoOnhover":"Ragam_logoOnhover__1v_F1"};